import {getFromStorage, removeFromStorage, storeToStorage} from "@/store/storage";

export const getRedirect = () => {
  return getFromStorage('redirect', '')
}
export const setRedirect = (url) => {
  console.log(url)
  storeToStorage('redirect', url)
}
export const removeRedirect = () => {
  removeFromStorage('redirect')
}
